import { Box, Link, Typography } from '@montugroup/design-system';
import PersonIcon from '@mui/icons-material/Person';
import { Avatar, Menu, MenuItem, styled } from '@mui/material';
import React, { useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import sagedLogo from '../saged_v2.png';

interface AdminMenuV2Props {
  firstName: string;
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginRight: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'baseline',
  },
}));

const AvatarBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  [theme.breakpoints.down('md')]: {
    marginTop: '2.5rem',
    paddingLeft: theme.spacing(6),
  },
}));

const CustomAvatar = styled(Avatar)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  marginLeft: theme.spacing(0),
}));

const Name = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  marginLeft: theme.spacing(3),
}));

const SagedLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  paddingRight: theme.spacing(6),
  color: theme.palette.common.white,
  textDecoration: 'none',
  '& img': {
    width: '35%',
    minWidth: 70,
    height: 'auto',
    transform: 'translateY(-1px)',
  },
  '&:hover': {
    color: theme.palette.common.white,
    textDecoration: 'none',
  },
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
    paddingLeft: theme.spacing(6),
    marginTop: theme.spacing(-6),
  },
}));

const SagedText = styled(Box)(({ theme }) => ({
  paddingRight: theme.spacing(2),
}));

const SagedContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down(1000)]: {
    display: 'none',
  },
  [theme.breakpoints.down('md')]: {
    display: 'block',
  },
}));

function AdminMenuV2({ firstName }: AdminMenuV2Props) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  return (
    <Container>
      <SagedContainer>
        <SagedLink href="https://saged.com.au/" target="_blank" rel="noopener" underline="none">
          <SagedText>Learn with</SagedText>
          <img src={sagedLogo} alt="Saged" />
        </SagedLink>
      </SagedContainer>
      <AvatarBox onClick={handleClick}>
        <CustomAvatar>
          <PersonIcon sx={{ color: 'secondary.main', fontSize: 25 }} />
        </CustomAvatar>
        <Name variant="body1">{firstName}</Name>
      </AvatarBox>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} disableScrollLock>
        <MenuItem component={RouterLink} to="/profile-detail">
          Profile
        </MenuItem>

        <MenuItem component={RouterLink} to={'/password'}>
          Password
        </MenuItem>
        <MenuItem component={RouterLink} to="/logout">
          Logout
        </MenuItem>
      </Menu>
    </Container>
  );
}

export default AdminMenuV2;
